<div class="generic-div">
    <div *ngIf="!widget?.html">
        Non ha HTML
    </div>
    <div *ngIf="widget?.html" [innerHTML]="widget?.html"></div>
</div>